<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M20.4284 8.42419L11.2618 0.196451C10.9631 -0.0710948 10.5038 -0.0645734 10.2135 0.211177L1.55602 8.43887C1.40782 8.57973 1.32404 8.77348 1.32404 8.97565V20.7936C1.32404 21.2068 1.66598 21.5416 2.08793 21.5416H8.45367C8.87558 21.5416 9.21757 21.2068 9.21757 20.7936V15.3085H12.7824V20.7936C12.7824 21.2068 13.1243 21.5416 13.5463 21.5416H19.912C20.3339 21.5416 20.6759 21.207 20.6759 20.7936V8.97569C20.6759 8.76599 20.5863 8.56606 20.4284 8.42419ZM19.1481 20.0457H14.3102V14.5606C14.3102 14.1475 13.9682 13.8126 13.5463 13.8126H8.45371C8.0318 13.8126 7.68981 14.1475 7.68981 14.5606V20.0457H2.85183V9.29208L10.7604 1.77619L19.1482 9.30479V20.0457H19.1481Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="21.5417" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'home'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>